import React, { useContext, useEffect, useState } from 'react'
import { Input, DropList } from '../../UIcomponent/Form'
import Col from '../../UIcomponent/Column'
import StyledButton from '../../UIcomponent/Button'
import { ThemeContext } from 'styled-components'
import Text from '../../UIcomponent/Text'
import CountryData from '../../Utility/CountryData'
import './RegisterForm.scss'
import OtpInput from 'react-otp-input';
import sortDown from '../../Assets/icon/sortDown.svg'
import { TimezoneList } from '../../Utility/TimezoneList'
import { Statistic } from 'antd'
import { Loader } from '../../UIcomponent/Loader'
const ForgotPasswordForm = (props) => {
    const timezoneData = TimezoneList
    const [showList, setShowList] = useState(false)
    const { Countdown } = Statistic;
    const [countries, setCountries] = useState(CountryData)
    const { flowType, formik, formErrosStyle, State, setState, lang, info, setInfo, FormEdit, ResendCode } = props
    const theme = useContext(ThemeContext)
    useEffect(() => {
    }, [])

    const onChangeFilter = (value, data, setState, filterKey1, filterKey2) => {
        let filterState = data.filter(each => (`${'+' + each[`${filterKey1}`]}`.toLowerCase().includes(value.toLowerCase()) || `${each[`${filterKey2}`]}`.toLowerCase().includes(value.toLowerCase())) && each)
        if (value.length !== 0) {
            setState(filterState)
        } else {
            setState(data)
        }
    }
    const phoneStrHandler = (code, phone) => {
        if (code === '+98' && `${phone}`[0] === '0') {
            return phone
        } else {
            return code + phone
        }
    }
    return (
        <>

            {State.hasVerifyCode === false &&
                <>
                    {flowType === 'mobile' && State.verifyCodeStatus === false &&

                        <Col
                            xl={24} lg={24} md={24} sm={24} xs={24}
                            style={{
                                justifyContent: 'space-between'
                            }}
                        >
                            <Col
                                xl={16} lg={16} md={16} sm={16} xs={16}
                                style={{
                                    flexDirection: 'column'
                                }}
                            >
                                <Input
                                    lang={lang}
                                    name='mobile'
                                    lable='mobile'
                                    disabled={State.hasVerifyCode}
                                    validateonchange={true}
                                    // validateonBlur={true}
                                    tabIndex={1}
                                    type='tel'
                                    placeholder='شماره موبایل'
                                />
                            </Col>
                            <Col
                                xl={6} lg={6} md={6} sm={6} xs={6}
                                style={{
                                    justifyContent: 'flex-end'
                                }}
                            >
                                <DropList
                                    show={showList}
                                    clicked={showList}
                                    type='tel'
                                    width='45px'
                                    value={formik.values.phoneCode}
                                    disabled={State.hasVerifyCode}
                                    id='phoneCode'
                                    name='phoneCode'
                                    onChange={(e) => {
                                        formik.setFieldValue('phoneCode', e.target.value)
                                        onChangeFilter(e.target.value, CountryData, setCountries, 'phoneCode')
                                    }}
                                    icon={sortDown}
                                    tabIndex={0}
                                    contentStyle={{
                                        width: '400%',
                                        left: '0px',
                                        top: '65px',
                                    }}
                                    onClick={() => setShowList(true)}
                                    onClose={() => setShowList(false)}>
                                    {showList && countries.length > 0 && countries.map((each, index) => {
                                        return (
                                            <Col
                                                xl={24} lg={24} md={24} sm={24} xs={24}
                                                style={{
                                                    justifyContent: 'space-evenly',
                                                    height: '35px',
                                                    minHeight: '35px',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    formik.setFieldValue('phoneCode', `+${each.phoneCode}`)
                                                    setTimeout(() => setShowList(false), 0)
                                                    setTimeout(() => {
                                                        setInfo({
                                                            ...info,
                                                            phoneCode: `+${each.phoneCode}`
                                                        })
                                                    }, 1)
                                                }}
                                            >
                                                <Col
                                                    xl={8} lg={8} md={8} sm={8} xs={8}
                                                    style={{
                                                        width: '25px',
                                                        height: '25px',
                                                        borderRadius: '10px',
                                                        backgroundColor: 'none',
                                                        backgroundImage: `url(https://www.countryflags.io/${each.code.toLowerCase()}/shiny/64.png)`
                                                    }}
                                                ></Col>
                                                <Col
                                                    xl={8} lg={8} md={8} sm={8} xs={8}
                                                    style={{
                                                        opacity: '0.7',
                                                        height: '100%',
                                                        fontSize: theme.fontSizeSm,
                                                        justifyContent: 'flex-end'
                                                    }}
                                                >
                                                    {each.value}
                                                </Col>
                                                <Col
                                                    xl={4} lg={8} md={8} sm={8} xs={8}
                                                    style={{
                                                        opacity: '0.7',
                                                        fontSize: theme.fontSizeMd,
                                                        fontWeight: 800,
                                                        justifyContent: 'flex-end'
                                                    }}
                                                >{each.phoneCode}+</Col>
                                            </Col>
                                        )
                                    })
                                    }
                                    {
                                        showList && countries.length === 0 &&
                                        <Col>
                                            موردی یافت نشد
                              </Col>
                                    }
                                </DropList>
                            </Col>
                        </Col>
                    }
                    {flowType === 'email' && State.verifyCodeStatus === false &&
                        <Input
                            tabIndex={1}
                            disabled={State.hasVerifyCode}
                            lang={lang}
                            id='email'
                            name='email'
                            lable='email'
                            // onChange={formik.handleChange}
                            validateOnChange={true}
                            type='email'
                            placeholder='ایمیل'
                        // value={formik.values.email}
                        />
                    }
                    <Col
                        xl={24} lg={24} md={24} sm={24} xs={24}
                    >
                        <Col
                            xl={12} lg={12} md={12} sm={12} xs={12}
                            style={formErrosStyle('flex-start')}
                        >{flowType === 'mobile' && formik.touched.mobile && formik.errors.mobile ? formik.errors.mobile :
                            flowType === 'email' && formik.touched.email && formik.errors.email ? formik.errors.email : ''}</Col>
                        <Col
                            xl={12} lg={12} md={12} sm={12} xs={12}
                            style={formErrosStyle('flex-end')}
                        >{formik.errors.phoneCode}</Col>

                    </Col>


                    {/* {State.hasVerifyCode === true && State.verifyCodeStatus === true && */}
                    <>
                        <Input
                            // disabled={State.hasVerifyCode}
                            lang={lang}
                            id='pass'
                            name='pass'
                            type='password'
                            tabIndex={2}
                            placeholder='رمز عبور جدید'
                        />
                        <Text
                            style={formErrosStyle(formik.touched.pass)}
                        >
                            {formik.touched.pass && formik.errors.pass}
                        </Text>
                    </>
                    {/* } */}
                </>
            }
            <Col
                xl={24} lg={24} md={24} sm={24} xs={24}
                style={{
                    marginTop: '15px',
                    flexDirection: 'column'
                }}
            >
                {
                    formik.isSubmitting === true && State.hasVerifyCode === true ?
                        <>
                            <Loader height={120} />
                            <Col
                                style={{
                                    height: '60px'
                                }}
                            >
                                چند لحظه منتظر بمانید ...
                            </Col>
                        </> :
                        <>
                            {State.mode === 'forgotPassword' && State.hasVerifyCode === false &&
                                <Col
                                    style={{
                                        color: theme.primary,
                                        fontSize: theme.fontSizeSm,
                                        fontWeight: 600,
                                        margin: '0px 0px 5px 0px',
                                        cursor: 'pointer',
                                        justifyContent: 'flex-start'
                                    }}
                                    xl={24} lg={24} md={24} sm={24} xs={24}
                                    onClick={() => setState({ ...State, mode: 'login' })}
                                >
                                    {State.mode === 'forgotPassword' ? 'بازگشت' : 'رمز عبور خود را فراموش کرده ام'}
                                </Col>
                            }
                            {State.hasVerifyCode === true && State.verifyCodeStatus === false &&
                                <>
                                    <Col
                                        style={{
                                            justifyContent: 'flex-start',
                                            height: '25px',
                                            color: theme.text,
                                            fontSize: theme.fontSizeSm
                                        }}
                                        xl={24} lg={24} md={24} sm={24} xs={24}
                                    >
                                        کد ارسال شده به <span
                                            style={{
                                                color: theme.textBold,
                                                fontWeight: '800',
                                                direction: 'ltr',
                                                height: '100%',
                                                fontSize: theme.fontSizeLg,
                                                fontFamily: 'Fa_IRANSans',
                                                padding: '5px',
                                                margin: '5px',
                                                borderRadius: '5px'
                                            }}
                                        >
                                            {flowType === 'mobile' ? phoneStrHandler(info.phoneCode, formik.values.mobile) : formik.values.email}

                                        </span> را وارد نمایید
                    </Col>
                                    <OtpInput
                                        value={formik.values.code}
                                        name='code'
                                        id='code'
                                        containerStyle={{
                                            display: 'flex',
                                            alignItems: 'flex-end',
                                            justifyContent: 'space-between',
                                            width: '100%',
                                            height: '50px',
                                            direction: 'ltr'
                                        }}
                                        inputStyle={{
                                            display: 'flex',
                                            border: 'none',
                                            width: '35px',
                                            color: theme.text,
                                            fontSize: theme.fontSizeLg,
                                            borderRadius: 'none',
                                            fontWeight: '800',
                                            fontFamily: 'Fa_IRANSans',
                                            borderBottom: `2px solid ${State.shake === false ? theme.secondary : theme.danger}`
                                        }}
                                        focusStyle={{
                                            border: 'none',
                                            outline: 'none'
                                        }}
                                        disabledStyle={{
                                            border: 'none',
                                            borderBottom: 'none',
                                            borderRadius: 'none',
                                            outline: 'none',
                                            opacity: '0.5',
                                            backgroundColor: 'transparent'
                                        }}
                                        shouldAutoFocus={true}
                                        onChange={otp => {
                                            formik.setFieldValue('code', otp)
                                            // InfoCtxt.setInfo({ ...InfoCtxt.info, Code: otp })
                                            // if (otp.length === 6) {
                                            //     setTimeout(() => formik.handleSubmit(), 1500)
                                            // }
                                        }}
                                        numInputs={6}
                                    />
                                </>
                            }
                            {State.hasVerifyCode === true ?
                                <Col
                                    xl={24} lg={24} md={24} sm={24} xs={24}
                                    style={{
                                        margin: '25px 0px 0px 0px',
                                        padding: '0px 0px 10px 0px'
                                    }}

                                >
                                    <Col
                                        style={{
                                            justifyContent: 'flex-start',
                                            color: theme.primary,
                                            fontSize: theme.fontSizeMd,
                                            cursor: 'pointer'
                                        }}
                                        xl={12} lg={12} md={12} sm={22} xs={22}
                                        onClick={() => FormEdit('forgotPassword')}
                                    >

                                        ویرایش اطلاعات
                     </Col>
                                    <Col
                                        style={{
                                            justifyContent: 'flex-end',
                                        }}
                                        xl={12} lg={12} md={12} sm={22} xs={22}
                                    >
                                        {State.hasVerifyCode === true &&
                                            State.expireTime !== null &&
                                            <Countdown
                                                valueStyle={{
                                                    color: theme.primary,
                                                    fontWeight: 600,
                                                    fontSize: theme.fontSizelg,
                                                    fontFamily: 'inherit',
                                                    letterSpacing: '2px'
                                                }}
                                                value={State.expireTime}
                                                format='mm:ss'
                                                onFinish={() =>
                                                    setState({
                                                        ...State,
                                                        expireTime: null
                                                    })
                                                }
                                            />
                                        }
                                        {State.hasVerifyCode === true
                                            && State.expireTime === null &&
                                            <Col
                                                onClick={() => ResendCode(formik, formik.values)}
                                                style={{
                                                    backgroundColor: theme.primary,
                                                    color: theme.white,
                                                    cursor: 'pointer',
                                                    fontWeight: 800,
                                                    fontSize: theme.fontSizeSm,
                                                    padding: '5px 8px 5px 8px',
                                                    borderRadius: theme.borderRadius
                                                }}
                                            >
                                                دریافت مجدد کد
                                            </Col>
                                        }
                                    </Col>
                                </Col>
                                : null
                            }
                            <StyledButton
                                tabIndex={2}
                                style={
                                    {
                                        marginTop: '5px',
                                        fontWeight: 800,
                                        fontSize: theme.fontSizelg,
                                        backgroundColor: theme.secondary,
                                        color: theme.white
                                    }
                                }
                                width={'100%'}
                                height='45px'
                                loading={formik.isSubmitting}
                                disable={formik.isValid === false}
                                type='submit'
                            >
                                {
                                    State.hasVerifyCode === true && State.verifyCodeStatus === false ? 'ارسال کد تایید' : State.hasVerifyCode === true && State.verifyCodeStatus === true ? 'تغییر رمز عبور' : 'ادامه'
                                }
                            </StyledButton>
                        </>
                }
            </Col>
        </>
    )
}


export default ForgotPasswordForm
